/* eslint-env browser */

const SELECTORS = {
  tileWishlistBtn: '.product-tile__wishlist--link',
  tileActionBtns: '.product-tile__action, .add-to-cart',
  sizeInput: '.product-tile__add-overlay-size-input',
  checkedSizeInput: '.product-tile__add-overlay-size-input:checked',
  sizesGrid: '.product-tile__add-overlay-sizes',
  sizeWrapper: '.product-tile__add-overlay-size-wrapper',
  cartBtn: '.add-to-cart',
  wishlistBtn: '.add-to-wish-list',
  sizeBtnContainer: '.product-tile__add-overlay-size-btn',
  selectedSize: '.sizelist .Selected',
};

const DATA_ATTRS = {
  constructorBtn: 'cnstrcBtn',
  constructorVariationId: 'cnstrcItemVariationId',
};

const CONSTRUCTOR_BTNS = {
  addToCart: 'add_to_cart',
  addToWishlist: 'add_to_wishlist',
};

const SIZE_SYNC_DELAY = 150;

function setConstructorBtn(element, value) {
  if (element) {
    element.dataset[DATA_ATTRS.constructorBtn] = value;
  }
}

function removeConstructorBtn(element) {
  if (element) {
    delete element.dataset[DATA_ATTRS.constructorBtn];
  }
}

function setTileVariationId(tile, variationId) {
  if (tile && variationId) {
    tile.dataset[DATA_ATTRS.constructorVariationId] = variationId;
  }
}

/**
 * Syncs Constructor wishlist tracking attribute.
 *
 * @param {Element} tile - Product tile element
 */
function handleWishlistAttribute(tile) {
  const wishlistBtn = tile.querySelector(SELECTORS.tileWishlistBtn);

  if (!wishlistBtn) return;

  if (wishlistBtn.classList.contains('active')) {
    removeConstructorBtn(wishlistBtn);
    return;
  }

  setConstructorBtn(wishlistBtn, CONSTRUCTOR_BTNS.addToWishlist);
}

/**
 * Syncs Constructor add-to-cart tracking attributes.
 *
 * @param {Element} tile - Product tile element
 */
function handleAddToCartAttribute(tile) {
  const buttons = tile.querySelectorAll(SELECTORS.tileActionBtns);

  buttons.forEach((btn) => {
    const isDirectAdd = btn.classList.contains('js-direct-add');
    const requiresSizeSelection = btn.classList.contains('js-requires-size');

    if (isDirectAdd) {
      setConstructorBtn(btn, CONSTRUCTOR_BTNS.addToCart);
      setTileVariationId(tile, btn.getAttribute('data-pid'));
      return;
    }

    if (!requiresSizeSelection) return;

    const hasSelectedSize = !!tile.querySelector(SELECTORS.selectedSize);

    if (hasSelectedSize) {
      setConstructorBtn(btn, CONSTRUCTOR_BTNS.addToCart);
    } else {
      removeConstructorBtn(btn);
    }
  });
}

/**
 * Syncs wishlist and add-to-cart Constructor tracking attributes.
 *
 * @param {Element} tile - Product tile element
 */
function syncBtnAttrs(tile) {
  if (!tile) return;

  handleWishlistAttribute(tile);
  handleAddToCartAttribute(tile);
}

function clearSizeWrapperConstructorAttrs(sizesGrid) {
  const wrappers = sizesGrid.querySelectorAll(SELECTORS.sizeWrapper);

  wrappers.forEach((wrapper) => {
    removeConstructorBtn(wrapper.querySelector(SELECTORS.cartBtn));
    removeConstructorBtn(wrapper.querySelector(SELECTORS.wishlistBtn));
  });
}

function syncSelectedSizeAttrs(tile, buttonWrapper) {
  const cartBtn = buttonWrapper.querySelector(SELECTORS.cartBtn);
  const variationId = cartBtn && cartBtn.getAttribute('data-pid');

  if (!variationId) return;

  setTileVariationId(tile, variationId);
  setConstructorBtn(cartBtn, CONSTRUCTOR_BTNS.addToCart);

  const sizeBtnContainer = buttonWrapper.querySelector(SELECTORS.sizeBtnContainer);
  const wishlistBtn = sizeBtnContainer && sizeBtnContainer.querySelector(SELECTORS.wishlistBtn);

  if (!wishlistBtn) return;

  setConstructorBtn(wishlistBtn, CONSTRUCTOR_BTNS.addToWishlist);

  const tileWishlistBtn = tile.querySelector(SELECTORS.tileWishlistBtn);
  removeConstructorBtn(tileWishlistBtn);
}

/**
 * Syncs Constructor tracking attributes after size selection.
 *
 * @param {Element} tile - Product tile element
 * @param {HTMLInputElement} input - Selected size input
 */
function handleSizeSync(tile, input) {
  const sizesGrid = input.closest(SELECTORS.sizesGrid);

  if (!sizesGrid) return;

  clearSizeWrapperConstructorAttrs(sizesGrid);

  const buttonWrapper = input.closest(SELECTORS.sizeWrapper);

  if (!buttonWrapper) return;

  setTimeout(() => {
    syncSelectedSizeAttrs(tile, buttonWrapper);
  }, SIZE_SYNC_DELAY);
}

/**
 * Handles size selection within a product tile overlay.
 * Supports pre-selected sizes on load and user-triggered changes.
 *
 * @param {Element} tile - Product tile element
 */
function bindPLPSizeSelection(tile) {
  if (!tile) return;

  const sizeInputs = tile.querySelectorAll(SELECTORS.sizeInput);

  if (!sizeInputs.length) return;

  const preCheckedInput = tile.querySelector(SELECTORS.checkedSizeInput);

  if (preCheckedInput) {
    handleSizeSync(tile, preCheckedInput);
  }

  sizeInputs.forEach((input) => {
    input.addEventListener('change', (event) => {
      if (event.target.checked) {
        handleSizeSync(tile, event.target);
      }
    });
  });
}

module.exports = {
  syncBtnAttrs,
  bindPLPSizeSelection,
};
